/* eslint-disable */
export const DEPARTMENT_BDM = 'Business Development (BD)';
export const DEPARTMENT_AA = 'Account Associates (AA)'; //Previously known as Sales
export const DEPARTMENT_MARKETING = 'Marketing'; 
export const DEPARTMENT_MANAGEMENT = 'Management';
export const DEPARTMENT_ADMIN = 'Administrations'; 
export const DEPARTMENT_HR = 'HR'; 
export const DEPARTMENT_OPERATIONS = 'Operations'; 
export const DEPARTMENT_IT = 'IT'; //
export const DEPARTMENT_CORPORATION = 'Corporation'; 